import React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { Typography } from '@mui/material';
import { ChartsYAxis } from '@mui/x-charts';

const data = [
  { name: '1 Nov', value: 10 },
  { name: '7 Nov', value: 20 },
  { name: '14 Nov', value: 30 },
  { name: '21 Nov', value: 40 },
  { name: '27 Nov', value: 40 },
];


const customize = {
  height: 300,
  legend: { hidden: true },
  margin: { top: 5 },
  stackingOrder: 'descending',
};


const LineChartComponent = () => {
  return (
    <LineChart
    height={300}
    xAxis={[{ data: [0, 1, 2, 3, 4, 5, 6] }]}
      series={[
        { curve: "linear", data: [6, 3, 7, 9.5, 4, 2] },
      ]}

    />
  );
};

export default LineChartComponent;
